import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "ApiClient";
import { ApiURL } from "utils/Actions";
import { API_RESPONSE_STATUS } from "utils/Constants";
import { showErrorModal } from "utils/hooks/handleNotification";
import { DocumentType } from "utils/Types";
import { common } from "utils/Wording";

type DocumentSliceType = {
  data: DocumentType[];
  isLoading: boolean;
  isLoadingError: boolean;
};

const DocumentInit: DocumentSliceType = {
  data: [] as DocumentType[],
  isLoading: false,
  isLoadingError: false
};

export const fetchDocuments = createAsyncThunk(
  ApiURL.qualificationDocument,
  async (parameters: { refNum: number; qualNum: number }) => {
    const { refNum, qualNum } = parameters;
    if (!refNum) {
      throw new Error(common.loadingError);
    }

    try {
      const res = await api.get(
        `${ApiURL.qualificationDocument}/${String(refNum)}/${String(qualNum)}`
      );
      if (res?.data?.status === API_RESPONSE_STATUS.ERROR) {
        throw new Error(common.loadingError);
      }
      const data = res?.data?.data ? res.data.data : [];
      return data;
    } catch (error: any) {
      showErrorModal({
        title: common.failAsync,
        errors: error.response?.data?.errors ? error.response.data.errors : [error.message]
      });
      return DocumentInit.data;
    }
  }
);

export const DocumentSlice = createSlice({
  name: "document",
  initialState: DocumentInit,
  reducers: {
    setDocuments: (state, action) => {
      return {
        ...state,
        data: action.payload,
        isLoading: false,
        isLoadingError: false
      };
    }
  },
  extraReducers: builder => {
    builder.addCase(fetchDocuments.pending, state => {
      state.isLoading = true;
      state.isLoadingError = false;
    });
    builder.addCase(fetchDocuments.fulfilled, (state, action) => {
      return {
        ...state,
        data: action.payload,
        isLoading: false,
        isLoadingError: false
      };
    }),
      builder.addCase(fetchDocuments.rejected, () => {
        return {
          data: DocumentInit.data,
          isLoading: false,
          isLoadingError: true
        };
      });
  }
});

export const { setDocuments } = DocumentSlice.actions;

export default DocumentSlice.reducer;
